import axios from "axios";
import {MortgageWatchQuery} from "@/utils/MortgageWatchQuery.ts";

export default {
    state: {
        watchers: [],
        userWatchers: []
    },
    
    getters: {
        userWatchers(state) {
            const tmp = [];
            state.userWatchers.forEach(item => {
                tmp.push(new MortgageWatchQuery(item));
            });
            return tmp;
        },
        
        watchers(state) {
            return state.watchers;
        },
        
        mostRecentWatcher(state) {
            return (state.watchers == null || state.watchers.length === 0)
                ? null
                : state.watchers[state.watchers.length - 1];
        },

        defaultWatcher(state) {
            const i = state.watchers.findIndex(item => item.name === "default");
            return i === -1 ? null : state.watchers[i];
        },

        getWatcher: (state) => (id) => {
            const tmp = state.userWatchers.find(i => i.uid === id);
            return tmp == null ? null : new MortgageWatchQuery(tmp);
//            return state.userWatchers.find(i => i.uid === id);
        }
    },
    
    actions: {
        setUserWatcherStatus(context, {owner, id, active}) {
            console.log("setUserWatcherStatus: " + owner + " / " + id + " / " + active);
            context.commit("setUserWatcherStatus", {id, active});
            if (owner == null) return;
            console.log(process.env.VUE_APP_MORTGAGEWATCH_API_URL + "/mortgagewatch/" + owner + "/" + id + "/alerts/" + (active ? "unmute" : "mute"));
            axios
                .post(process.env.VUE_APP_MORTGAGEWATCH_API_URL + "/mortgagewatch/" + owner + "/" + id + "/alerts/" + (active ? "unmute" : "mute"))
                .then(response => {
                    console.log("setUserWatcherStatus success: "+ owner + "/" + id);
                })
                .catch(error => {
                    console.log("setUserWatcherStatus failed => " + error);

                    throw error;
                });
        },
        
        deleteUserWatcher(context, {owner, id}) {
            console.log("deleteUserWatcher: " + owner + " / " + id);
            context.commit("deleteUserWatcher", id);
            if (owner == null) return;
            
            axios
                .delete(process.env.VUE_APP_MORTGAGEWATCH_API_URL + "/mortgagewatch/" + owner + "/" + id)
                .then(response => {
                    console.log("deleteUserWatcher success: "+ owner + "/" + id);
                })
                .catch(error => {
                    console.log("saveUserWatcher failed => " + error);

                    throw error;
                });
        },
        
        async saveUserWatcher(context, {owner, data}) {
            if (owner == null) return;
            await axios
                .post(process.env.VUE_APP_MORTGAGEWATCH_API_URL + "/mortgagewatch/" + owner, data)
                .then(response => {
                    context.commit('saveUserWatcher', response.data);
                    console.log("saveUserWatcher success: "+ owner);// + " - " + JSON.stringify(data));
                })
                .catch(error => {
                    console.log("saveUserWatcher failed => " + error);

                    throw error;
                });
        },
        
        loadMortgageWatchers(context, owner) {
            axios
                .get(process.env.VUE_APP_MORTGAGEWATCH_API_URL + "/mortgagewatch/" + owner)
                .then(response => {
                    console.log("loadMortgageWatchers: " + JSON.stringify(response.data));
                    context.commit("setUserWatchers", response.data);
                })
                .catch(error => console.log("loadMortgageWatchers failed: " + error));
        },

        addWatcher(context, item) {
            context.commit("addWatcher", item);
        },
        
        removeWatcher(context, item) {
            context.commit("removeWatcher", item);
        }
    },
    
    mutations: {
        setUserWatcherStatus(state, payload) {
            const tmp = state.userWatchers.find(item => item.uid === payload.id);
            if (tmp != null) {
                tmp.alerts.active = payload.active;
            }
        },
        
        deleteUserWatcher(state, payload) {
            state.userWatchers = state.userWatchers.filter(item => item.uid !== payload);
        },
        
        saveUserWatcher(state, payload) {
            state.userWatchers = state.userWatchers.filter(item => item.uid !== payload.uid);
            state.userWatchers.push(payload);
        },
        
        setUserWatchers(state, payload) {
            state.userWatchers = payload;
        },

        addWatcher(state, payload) {
            state.watchers = state.watchers.filter(item => item.name !== payload.name);
            
            state.watchers.push(payload);
        },
        
        removeWatcher(state, payload) {
            state.watchers = state.watchers.filter(item => item.name !== payload.name);
        }
    }
}